import { useCallback } from 'react';
import { hasCollaborationMethodOption } from '@99designs/design-services-common';
import { useProductOptionsLazyQuery } from '../../../graph';
import { ProductOptionsQuery } from '../../../graph/ProductOptions.generated';

type ProductOptions = ProductOptionsQuery['productOptions'];

/**
 * Returns a stable function that fetches product options for a given service product
 * and determines whether it supports CollaborationMethodOption.
 */
export function useServiceProductOptions() {
    const [fetchProductOptions] = useProductOptionsLazyQuery();

    return useCallback(
        async (
            productKey: string,
            version: number
        ): Promise<{ supportsCollaborationMethod: boolean; productOptions: ProductOptions }> => {
            const { data } = await fetchProductOptions({
                variables: { key: productKey, version },
            });

            const productOptions = data?.productOptions ?? [];

            return {
                supportsCollaborationMethod: hasCollaborationMethodOption(productOptions),
                productOptions,
            };
        },
        [fetchProductOptions]
    );
}
